import { IntlShape } from "react-intl";
import Messages from "../localization/Messages";
import { UserData, UserRole } from "./userData";
import { UserHasRole } from "../helpers/RolesHelper";
import { initPdpQuestionAndAnswer, IPdpQuestionAndAnswer } from "./pdpQuestionAndAnswer";

export interface IPdp {
    userGuid?: string;
    userFullName?: string;
    guid?: string;
    date: string;
    title: string;
    comment: string;
    status: PdpStatus;
    hasQuestions?: boolean;
    hasAnswers?: boolean;
    questionsAndAnswers?: IPdpQuestionAndAnswer[];
    shouldSendEmail?: boolean;
}

export enum PdpStatus {
    Created = 1,
    Pending = 2,
    Completed = 3,
}

export const getPdpQuestions = () => {
    return [
        { key: 1, message: Messages.pdpQuestionCurrentSituation },
        { key: 2, message: Messages.pdpQuestionCareerGoals },
        { key: 3, message: Messages.pdpQuestionSkillGaps },
        { key: 4, message: Messages.pdpQuestionActions },
        { key: 5, message: Messages.pdpQuestionEvaluation },
    ];
};

export const initPdp: IPdp = {
    userGuid: undefined,
    guid: undefined,
    date: "",
    title: "",
    comment: "",
    status: PdpStatus.Created,
    questionsAndAnswers: getPdpQuestions().map(q => ({
        ...initPdpQuestionAndAnswer,
        title: q.message.defaultMessage,
        question: q.message.description,
    })),
};

export const getPdpStatusOptions = (intl: IntlShape, isAdmin: boolean) => {
    const options =  [
        { key: PdpStatus.Created, label: intl.formatMessage(Messages.created) },
        { key: PdpStatus.Pending, label: intl.formatMessage(Messages.pending) },
        { key: PdpStatus.Completed, label: intl.formatMessage(Messages.completed) },
    ];

    if(!isAdmin) {
        return options.filter(o => o.key !== PdpStatus.Created);
    }
    return options;
};

